module.exports = __webpack_public_path__ + "static/marketing-2b4ad5bbf2eda6eafddc821158e0c299.jpg";